import React, { useState } from 'react';
import { CustomTable, ModalWrapper } from '../../../../components';
import { useTable } from '../../../../hooks/index.hook';
import { Columns, getEquipmentWarrantyCertificateDetailsService, uploadWarrantyCertificateService } from '../../../../services/index.service';
import { downloadFile, modalNotification } from '../../../../utils';
import UploadWarrantyReceipt from '../../UploadWarranty/upload';

const handleView = (row) => {
  if (row?.getCertificateUrl) {
    downloadFile(row.getCertificateUrl);
  } else {
    modalNotification({
      type: 'error',
      message: 'No receipt available to download.',
    });
  }
};

function EquipmentWarrantyCertificateDetails({ rowData }) {
  const [state, setState] = useState({
    loader: null,
    modal: null,                 // 'upload-file' to open
    modalId: null,
    selectedRows: null,          // <-- make this an object, not an array
    submitText: 'add',
    options: {},
    isAlertVisible: false,
    updateId: null,
    updateStatus: 'save',
    isLoading: false,
    globalFilter: false,
  });

  const handleStateChange = (name, value) => {
    if (typeof name === 'string') {
      setState((prev) => ({ ...prev, [name]: value }));
    } else {
      setState((prev) => ({ ...prev, ...name }));
    }
  };

  const onCancel = () => {
    handleStateChange({ modal: null, selectedRows: null });
  };

  const handleReceiptUpload = async (values) => {
    try {
      const bodyData = {
        ahriCertificateUrl: (values?.ahriCertificateUrl ?? '').replace(/^https?:\/\/[^/]+\/?/, '') || null,
        warrantyPaperCertificateUrl: (values?.warrantyPaperCertificateUrl ?? '').replace(/^https?:\/\/[^/]+\/?/, '') || null,
        otherCertificateTitle: values?.warrantyTitle ?? null,
        warrantyCertificateUrl: (values?.warrantyCertificate ?? '').replace(/^https?:\/\/[^/]+\/?/, '') || null,
      };

      const response = await uploadWarrantyCertificateService({
        bodyData,
        id: state.selectedRows.equipmentId,
      });
      if (response?.success) {
        onRefresh();
        handleStateChange('modal', '');
      }
    } catch (error) {
      console.log(error);
      modalNotification({
        type: 'error',
        message: error?.message,
      });
    }
  };

  const equipmentId = rowData?.id;
  const extraQuery = { equipmentId };

  const [tableHandler, tableProps] = useTable(
    getEquipmentWarrantyCertificateDetailsService,
    extraQuery,
  );
  const { data, isLoading } = tableProps;
  const { onFilterResetChange, onTableSort, onFilterChange, onRefresh } =
    tableHandler;
  // Safely handle both { success, data: {...} } and {...} shapes (and initial undefined)
  const details = (data && (data.data ?? data)) || {};

  // Normalize single-object API -> 3 display rows
  const finalData = [
    {
      id: 'ahri',
      heId: details.id,
      title: 'AHRI Certificate',
      getCertificateUrl: details.getAhriCertificateUrl ?? null,
    },
    {
      id: 'paperwork',
      heId: details.id,
      title: 'Warranty Paperwork',
      getCertificateUrl: details.getWarrantyPaperCertificateUrl ??
        null,
    },
    {
      id: 'warranty',
      heId: details.id,
      title: details.otherCertificateTitle ?? 'Warranty Certificate',
      getCertificateUrl: details.getWarrantyCertificateUrl ?? null,
    },
  ];

  const handleUpload = (row) => {
    // include equipmentId so the upload form has context
    handleStateChange('modal', 'upload-file');
    handleStateChange('selectedRows', { ...row, equipmentId });
  };

  const columns = Columns.quipmentWarrantyCertificateDetailsColumn({
    page: 1,
    sizePerPage: 20,
    handleView,
    handleUpload,
  });
  return (
    <>
      <CustomTable
        tableData={finalData}
        pagination={false}
        tableColumns={columns}
        tableLoader={isLoading}
      // rowKey is optional if your CustomTable infers it; otherwise:
      // rowKey="id"
      />

      {/* ⬇️ Upload modal */}
      <ModalWrapper
        onCancel={onCancel}
        extraClassName="modal-dialog-scrollable"
        content={
          <UploadWarrantyReceipt
            // { id: 'ahri'|'paperwork'|'warranty', title, url, equipmentId }
            receiptData={state.selectedRows}
            title={state.selectedRows?.title === 'AHRI Certificate' ? "ahriCertificateUrl" : state.selectedRows?.title === 'Warranty Paperwork' ? "warrantyPaperCertificateUrl" : "warrantyCertificate"}
            onSubmit={handleReceiptUpload}
            url={state.selectedRows?.getCertificateUrl}
          />
        }
        heading="Warranty Receipt"
        show={state.modal === 'upload-file'}
      />
    </>
  );
}

export default EquipmentWarrantyCertificateDetails;
